// src/mazeLogic.js
import { getRng } from './utils/random';

/**
 * ????? ????? ????? ??? ??????? ???? Seed
 * @param {string} difficulty - ?????????: 'easy', 'medium', 'hard', 'expert'
 * @param {string} seed - ????? ???????? ????? ???? ???????
 */
export const generateMaze = (difficulty = 'medium', seed = null) => {
  const rng = getRng(seed);

  // 1. ????? ??? ???????? (??????) ????? ??? ???????
  let width, height;
  switch (difficulty.toLowerCase()) {
    case 'easy':
      width = 12; height = 12; // ???? ????? ??????? ?????
      break;
    case 'medium':
      width = 20; height = 20; // ????? ??????
      break;
    case 'hard':
      width = 30; height = 30; // ???? ????? ??????? ????
      break;
    case 'expert':
      width = 45; height = 45; // ????? ????? ???? ?????? ??????
      break;
    default:
      width = 20; height = 20;
  }

  // ????? ???? ??????? ???????
  let maze = [];
  for (let y = 0; y < height; y++) {
    let row = [];
    for (let x = 0; x < width; x++) {
      row.push({
        x, y,
        top: true, right: true, bottom: true, left: true,
        visited: false
      });
    }
    maze.push(row);
  }

  // ???????? Recursive Backtracking ?????? ????????
  const stack = [];
  const start = maze[0][0];
  start.visited = true;
  stack.push(start);

  while (stack.length > 0) {
    const current = stack[stack.length - 1];
    const neighbors = [];
    const { x, y } = current;

    if (y > 0 && !maze[y - 1][x].visited) neighbors.push('top');
    if (x < width - 1 && !maze[y][x + 1].visited) neighbors.push('right');
    if (y < height - 1 && !maze[y + 1][x].visited) neighbors.push('bottom');
    if (x > 0 && !maze[y][x - 1].visited) neighbors.push('left');

    if (neighbors.length > 0) {
      const randomDir = neighbors[Math.floor(rng() * neighbors.length)];
      let next;
      if (randomDir === 'top') {
        next = maze[y - 1][x];
        current.top = false;
        next.bottom = false;
      } else if (randomDir === 'right') {
        next = maze[y][x + 1];
        current.right = false;
        next.left = false;
      } else if (randomDir === 'bottom') {
        next = maze[y + 1][x];
        current.bottom = false;
        next.top = false;
      } else if (randomDir === 'left') {
        next = maze[y][x - 1];
        current.left = false;
        next.right = false;
      }

      next.visited = true;
      stack.push(next);
    } else {
      stack.pop();
    }
  }

  // ????? ??????? ?? ???????? ?????? ??? ?????? ???? ???? cellSize
  return { maze, width, height };
};

export const solveMaze = (mazeData) => {
  const { maze, width, height } = mazeData;
  const start = { x: 0, y: 0 };
  const end = { x: width - 1, y: height - 1 };
  
  let queue = [[start]];
  let visited = new Set(['0,0']);

  while (queue.length > 0) {
    let path = queue.shift();
    let current = path[path.length - 1];

    if (current.x === end.x && current.y === end.y) return path;

    const directions = [
      { key: 'top', dx: 0, dy: -1 },
      { key: 'right', dx: 1, dy: 0 },
      { key: 'bottom', dx: 0, dy: 1 },
      { key: 'left', dx: -1, dy: 0 }
    ];

    for (let dir of directions) {
      if (!maze[current.y][current.x][dir.key]) { 
        let nx = current.x + dir.dx;
        let ny = current.y + dir.dy;
        if (nx >= 0 && nx < width && ny >= 0 && ny < height && !visited.has(`${nx},${ny}`)) {
          visited.add(`${nx},${ny}`);
          queue.push([...path, { x: nx, y: ny }]);
        }
      }
    }
  }
  return [];
};